<template>    
        <v-container fluid pa-0>
         <v-list v-if="(editedItems != []) && (editedItems[0].promos) && (editedItems[0].promos.length > 0)"
         dense fluid>                 
                 <v-layout row wrap>
                    <v-flex xs6>
                        <v-subheader class="nopadding compact blue--text">Promociones</v-subheader> 
                    </v-flex>
                   
                    <v-flex xs2>
                        <v-subheader class="nopadding compact blue--text">Cant Min</v-subheader> 
                    </v-flex>
                    <v-flex xs2>
                        <v-subheader class="nopadding compact blue--text">Alcance</v-subheader> 
                    </v-flex>
                    <v-flex xs2>                    
                    </v-flex>
                    </v-layout>                    
                <v-list-tile
                v-for="(promo, i) in editedItems[0].promos"
                :key="i"                
                >       
                <v-layout row wrap >
                    <v-flex xs2>
                        {{promo.itemPromo}}
                    </v-flex>
                    <v-flex xs4>
                        {{promo.promoCode}}
                    </v-flex>
                    <v-flex xs2>
                        {{promo.minQty}}
                    </v-flex>
                    <v-flex xs2>
                        <span v-if="promo.SalesType == 'All Customers'">Todos</span>
                        <span v-if="promo.SalesType == 'Customer'">Cliente</span>
                    </v-flex>
                    <v-flex xs2>
                        {{promo.salesCode}}
                    </v-flex>
                    <v-flex xs10 pa-0 offset-xs2>
                        <span v-if="promo.startingDateFormat && promo.endingDateFormat">(Desde {{promo.startingDateFormat}} al {{promo.endingDateFormat}})</span>
                        <span v-if="promo.startingDateFormat && !promo.endingDateFormat">(Desde {{promo.startingDateFormat}})</span>
                    </v-flex>
                </v-layout>      
                </v-list-tile>
        </v-list>
        </v-container>

</template>
<script>
export default {
    name: 'promocionesArticulo',    
    data(){
        return{

        }
    },
    computed:{
        editedItems:{
            get(){
                return this.$store.state.editedItems;
            },
            set(value){
                this.$store.state.editedItems = value;
            }
        }
    }
}
</script>
<style scoped>
.nopadding{
    padding: 0px;
}
.compact{
    height: 20px;
}
</style>